import TenantProfileForm from './TenantProfileForm'

export default TenantProfileForm
